import { BigNumber } from 'ethers';

// add 20%
export function calculateGasMargin(value: BigNumber, maxGas: number): BigNumber {
  const gas = value.mul(BigNumber.from(10000 + 2000)).div(BigNumber.from(10000));

  if (gas.gt(maxGas)) throw new Error('Gas limit too high, something is wrong');

  return gas;
}
